import { BrowserRouter } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import reportWebVitals from "./reportWebVitals";
import { createRoot } from "react-dom/client";
import { AppContext } from "./hooks";
import { StrictMode } from "react";
const container = document.getElementById("root");
const root = createRoot(container);
root.render(
  <HelmetProvider>
    <BrowserRouter basename="/">
      <StrictMode>
        <AppContext>
          <App />
        </AppContext>
      </StrictMode>
    </BrowserRouter>
  </HelmetProvider>,
);

serviceWorker.unregister();

reportWebVitals();
